function sentence(array) {
  const arrayStart = array.slice(0, -1).join(', ');

  const arrayEnd = array.slice(-1);
  const conjunction = array.length <= 1 ? '' : ' y ';

  return [arrayStart, arrayEnd].join(conjunction);
}

export default sentence;
